angular.module('AccountingBoxApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('app.company.reporting', {
                url: '/rapportage',
                abstract: true,
                templateUrl: 'app/reporting/reporting.html',
                controller: 'ReportingCtrl',
                controllerAs: 'r'
            })
            .state('app.company.reporting.journals', {
                url: '/journalen',
                templateUrl: 'app/reporting/journals/journals.html',
                controller: 'ReportingJournalsCtrl',
                controllerAs: 'rj'
            })
            .state('app.company.reporting.tAccount', {
                url: '/grootboekrekening',
                templateUrl: 'app/reporting/tAccount/tAccount.html',
                controller: 'ReportingTAccountCtrl',
                controllerAs: 'rta'
            })
            .state('app.company.reporting.balanceSheet', {
                url: '/kolommenbalans',
                templateUrl: 'app/reporting/balanceSheet/balanceSheet.html',
                controller: 'ReportingBalanceSheetCtrl',
                controllerAs: 'rbs'
            })
            .state('app.company.reporting.vatReturn', {
            url: '/btw-aangifte',
            templateUrl: 'app/reporting/vatReturn/vatReturn.html',
            controller: 'ReportingVATReturnCtrl',
            controllerAs: 'rvr'
            })
            .state('app.company.reporting.openSales', {
            url: '/openstaande-debiteuren',
            templateUrl: 'app/reporting/openSales/openSales.html',
            controller: 'OpenSalesCtrl',
            controllerAs: 'ros'
            })
            .state('app.company.reporting.openPurchases', {
            url: '/openstaande-crediteuren',
            templateUrl: 'app/reporting/openPurchases/openPurchases.html',
            controller: 'OpenPurchasesCtrl',
            controllerAs: 'rop'
            })
            .state('app.company.reporting.yearClosure', {
            url: '/jaar-afsluiting',
            templateUrl: 'app/reporting/yearClosure/yearClosure.html',
            controller: 'ReportingYearClosureCtrl',
            controllerAs: 'ryc'
            });
    });
